import { memo } from 'react'
import TableCell from '@material-ui/core/TableCell'
import Typography from '@material-ui/core/Typography'
import M_TableCell from 'components/1_Atoms/2_Molecules/M_TableCell'
import { getStyle } from 'assets/TableHeader'
import { userTableSummary } from 'assets/TableHeader'
import { responseUser } from 'utils/requestUtil'
import { useCheck } from 'hooks/useUserTorokuTable'

type Props = {
  user: responseUser
  isChecked: boolean
}
const width = userTableSummary.width
const manualMode = process.env.REACT_APP_MANUAL_MODE === '1'

const O_TableRowUserSummary = ({ user, isChecked }: Props) => {
  const [check] = useCheck(user, isChecked)

  return (
    <>
      {/* チェックボックス */}
      <M_TableCell category="checkbox" isChecked={isChecked} width={width.CHECK} click={check} />
      {/* 得意先コード */}
      <TableCell
        style={getStyle(width.TOKUI_CD)} //
        align="left"
        onClick={check}
      >
        <Typography variant="caption">{user.TOKUI_CD}</Typography>
      </TableCell>
      {/* 得意先名 */}
      <M_TableCell
        category="data" //
        width={width.TOKUI_NM}
        align="left"
        title={user.TOKUI_NM}
        data={user.TOKUI_NM}
        click={check}
        blackout={manualMode}
      />
      {/* 店舗コード */}
      <TableCell
        style={getStyle(width.TEN_CD)} //
        align="left"
        onClick={check}
      >
        <Typography variant="caption">{user.TEN_CD}</Typography>
      </TableCell>
      {/* 店舗名 */}
      <M_TableCell
        category="data" //
        width={width.TEN_NM}
        align="left"
        title={user.TEN_NM}
        data={user.TEN_NM}
        click={check}
        blackout={manualMode}
      />
      {/* メールアドレス */}
      <M_TableCell
        category="data" //
        width={width.MAIL}
        align="left"
        title={user.MAIL}
        data={user.MAIL}
        disabled={!isChecked}
        click={check}
        blackout={manualMode}
      />
      {/* 氏名 */}
      <M_TableCell
        category="data" //
        width={width.NAME}
        align="left"
        title={user.NAME}
        data={user.NAME}
        click={check}
        blackout={manualMode}
      />
    </>
  )
}
export default memo(O_TableRowUserSummary)
